export default __webpack_public_path__ + "static/media/swap-canvases.8b0506ee.svg";